<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
	<div class="bs-container">
		<div
			class="col-span-12 flex flex-col items-center justify-center gap-32px py-96px"
		>
			<div
				class="bs-new-icon icon-no-order-avail h-[150.65px] w-[168px] mdp:h-[200.8px] mdp:w-[224px] mdl:h-[269px] mdl:w-[300px]"
			></div>
			<div class="typography-h5-str text-center text-n-950">
				{{ t('pcs_no_order_available') }}
			</div>
		</div>
	</div>
</template>
